<template>
    <div>
        <v-row class="my-1" align="stretch">
            <v-col class="py-1 d-flex" cols="12" sm="6" md="6" lg="6">
                <DenseActionCard title="Editer les informations" :description="actionEditInscription.description"
                    icon="mdi-pencil-outline" :toPage="actionEditInscription.toPage"
                    :disabled="actionEditInscription.disabled" class="flex-grow-1">
                </DenseActionCard>
            </v-col>
            <v-col class="py-1 d-flex" cols="12" sm="6" md="6" lg="6">
                <DenseActionCard title="Documents du participant" :description="actionDocuments.description"
                    icon="mdi-file-document-outline" :toPage="actionDocuments.toPage"
                    :disabled="actionDocuments.disabled" :redBg="actionDocuments.redBg" class="flex-grow-1">
                </DenseActionCard>
            </v-col>
            <v-col class="py-1 d-flex" cols="12" sm="6" md="6" lg="6">
                <DenseActionCard title="Renvoyer le mail d'inscription" :description="actionMailInscription.description"
                    icon="mdi-email-outline" @click="sendMailInscription" class="flex-grow-1">
                </DenseActionCard>
            </v-col>
            <v-col class="py-1 d-flex" cols="12" sm="6" md="6" lg="6">
                <DenseActionCard title="Télécharger le billet" description="au format PDF" icon="mdi-download"
                    :toUrl="actionDownloadBillet.toUrl" class="flex-grow-1">
                </DenseActionCard>
            </v-col>
            <v-col class="py-1 d-flex" cols="12" sm="6" md="6" lg="6" v-if="showActionAlerteSMS">
                <DenseActionCard title="Alerte SMS" :description="actionAlerteSMS.description"
                    icon="mdi-message-processing-outline" :toPage="actionAlerteSMS.toPage"
                    :disabled="actionAlerteSMS.disabled" class="flex-grow-1">
                </DenseActionCard>
            </v-col>
            <v-col class="py-1 d-flex" cols="12" sm="6" md="6" lg="6">
                <DenseActionCard title="Transférer mon inscription" :description="actionTransferInscription.description"
                    icon="mdi-swap-horizontal" :toPage="actionTransferInscription.toPage"
                    :disabled="actionTransferInscription.disabled" class="flex-grow-1">
                </DenseActionCard>
            </v-col>
            <v-col class="py-1 d-flex" cols="12" sm="6" md="6" lg="6">
                <DenseActionCard title="Vendre mon inscription" :description="actionSellInscription.description"
                    icon="mdi-cash" :toPage="actionSellInscription.toPage" :disabled="actionSellInscription.disabled"
                    class="flex-grow-1">
                </DenseActionCard>
            </v-col>
            <v-col class="py-1 d-flex" cols="12" sm="6" md="6" lg="6">
                <DenseActionCard title="Changer de parcours" :description="actionSwitchParcours.description"
                    icon="mdi-routes" :toPage="actionSwitchParcours.toPage" :disabled="actionSwitchParcours.disabled"
                    class="flex-grow-1">
                </DenseActionCard>
            </v-col>
            <v-col class="py-1 d-flex" cols="12" sm="6" md="6" lg="6" v-if="showActionRefundGIA">
                <DenseActionCard title="Remboursement via la GIA" :description="actionRefundGIA.description"
                    icon="mdi-cash-refund" :toPage="actionRefundGIA.toPage" :disabled="actionRefundGIA.disabled"
                    class="flex-grow-1">
                </DenseActionCard>
            </v-col>
            <v-col class="py-1 d-flex" cols="12" sm="6" md="6" lg="6" v-if="is_free_commande">
                <DenseActionCard title="Supprimer mon inscription"
                    description="Et libérer ma place pour un autre participant" icon="mdi-delete"
                    @click="deleteInscription" class="flex-grow-1">
                </DenseActionCard>
            </v-col>

        </v-row>
        <v-dialog width="500" max-width="100%" v-model="deleteDialog" scroll-strategy="none">
            <v-card>
                <v-card-text>
                    <div class="text-h6 text-center font-weight-bold mb-2">
                        Supprimer mon inscription
                    </div>
                    <div class="text-body-1 text-center">
                        Etes-vous sûr de vouloir supprimer cette inscription ? <br />
                        <span class="text-red-darken-4 font-weight-bold">Cette action est irréversible.</span>
                    </div>
                    <div class="d-flex justify-center flex-wrap gap mt-4">
                        <v-btn color="dark-red" variant="text" @click="deleteDialog = false">Annuler</v-btn>
                        <v-btn color="dark-green" variant="text" @click="confirmDelete"
                            :loading="loadingDelete">Confirmer</v-btn>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import UserService from "@/services/user.service.js";
export default {
    name: 'ActionCardInscription',

    props: {
        inscription: {
            type: Object,
            required: true
        },
        all_commande_inscription: {
            type: Object,
            required: true
        },
        gia: {
            type: Object,
            required: false
        },
        alerte_sms: {
            type: Object,
            required: false
        },
        is_free_commande: {
            type: Boolean,
            required: false
        }
    },
    data() {
        return {
            base_url: process.env.VUE_APP_API_BASE,
            deleteDialog: false,
            loadingDelete: false
        }
    },
    computed: {
        ...mapStores(useMainStore),
        emailInscription() {
            if (this?.inscription?.champs?.mail && this?.inscription?.champs?.mail != "") {
                return this.inscription.champs.mail;
            }
            return this.mainStore.authUser.userMail;
        },
        actionEditInscription() {
            let response = {
                disabled: false,
                description: "de cette inscription",
                toPage: { name: 'EditInscription', params: { id_inscription: this.inscription.id } }
            }
            if (this.moduleClosed) {
                response.disabled = true;
                response.description = "Les inscriptions sont closes, vous ne pouvez plus modifier cette inscription";
            }
            return response;
        },
        actionDocuments() {

            const accept_pps = this.mainStore.module.accept_pps;
            const label = accept_pps ? "Veuillez charger votre PPS ou document justificatif" : "Veuillez charger votre document justificatif";
            let response = {
                disabled: false,
                description: label,
                redBg: true,
                toPage: { name: 'EditDocument', params: { id_inscription: this.inscription.id } }
            }
            if (this.inscription.champs?.["type_document"] == undefined) {
                response.toPage = { name: 'EditInscription', params: { id_inscription: this.inscription.id } }
            }
            if (this.inscription.document_recu == '1') {
                response.redBg = false;
                response.description = "Le document est en cours de validation";
            }
            if (this.inscription.document_valide == '1') {
                response.redBg = false;
                response.description = "Le document est validé, aucune action nécessaire";
            }
            const date_fin_documents = this.mainStore.module.date_fin_documents;
            if (!date_fin_documents && this.moduleClosed) {
                response.disabled = true;
                response.description = "Les inscriptions sont closes, vous ne pouvez plus modifier cette inscription";
            }
            if (date_fin_documents) {
                const date_fin_documents_endofday = this.$moment(date_fin_documents).endOf("day");
                const now = this.$moment();
                let beforeCloseDocumentsLimit = now.isBefore(date_fin_documents_endofday);
                if (!beforeCloseDocumentsLimit) {
                    response.disabled = true;
                    response.description = "Les inscriptions sont closes, vous ne pouvez plus modifier cette inscription";
                }
            }
            return response;
        },
        actionMailInscription() {
            let response = {
                disabled: false,
                description: "à " + this.emailInscription
            }
            return response;
        },
        actionDownloadBillet() {
            let response = {
                disabled: false,
                description: "au format PDF",
                toUrl: this.base_url + 'billet/get.php?id_inscription=' + this.inscription.id_crypted
            }
            return response;
        },
        actionTransferInscription() {
            let response = {
                disabled: false,
                description: "à un autre participant",
                toPage: { name: 'RequestTransfertInscription', params: { id_inscription: this.inscription.id } }
            }
            if (this.moduleClosed) {
                response.disabled = true;
                response.description = "Les inscriptions sont closes, vous ne pouvez plus transférer cette inscription";
            }

            if (this.inscription.from_transfert == 1) {
                response.disabled = true;
                response.description = "Cette inscription provient d'un transfert, vous ne pouvez pas la transférer à nouveau.";
            }
            if (this.inscription.inscription_sportive == 0) {
                response.disabled = true;
                response.description = "Seule les inscriptions sportives peuvent être transferées.";
            }
            if (this.all_commande_inscription.inscriptions.length > 1) {
                response.disabled = true;
                response.description = "Le transfert d'inscription n'est pas autorisé pour les inscriptions à des packs de courses.";
            }
            if (!this.mainStore.module.autoriser_transfert_dossard) {
                response.disabled = true;
                response.description = "Le transfert d'inscription n'est pas autorisé sur cet évènement.";
            }
            if (this.mainStore.module.has_limite_transfert_dossard && this.$moment(this.mainStore.module.metadatas.limite_transfert_dossard).endOf("day").isBefore(this.$moment())) {
                response.disabled = true;
                response.description = "Le date limite de transfert d'inscription est dépassée.";
            }
            if (this.inscription.bourse_dossards_status == 'PENDING' || this.inscription.bourse_dossards_status == 'PENDING_PAYMENT') {
                response.disabled = true;
                response.description = "Vous ne pouvez pas transférer cette inscription car elle est en vente sur la bourse aux dossards.";
            }
            return response;
        },
        actionSellInscription() {
            let response = {
                disabled: false,
                description: "sur la bourse aux dossards",
                toPage: { name: 'RequestBourseDossardInscription', params: { id_inscription: this.inscription.id } }
            }

            /* if (this.inscription?.course?.type == "relais" || this.inscription?.course?.type == "duo") {

                if (!this.mainStore.authAdmin.hasSuperAdminRights) {
                    response.disabled = true;
                    response.description = "La bourse aux dossards n'est pas disponible pour les courses en équipe.";
                }
            } */
            if (this.actionTransferInscription.disabled) {
                response.disabled = true;
                response.description = this.actionTransferInscription.description;
            }
            if (!this.mainStore.module.has_bourse_dossards) {
                response.disabled = true;
                response.description = "La bourse aux dossards n'est pas disponible sur cet évènement.";
            }
            if (this.inscription?.bourse_dossards_status == 'PENDING') {
                response.disabled = true;
                response.description = "Cette inscription est déjà en vente sur la bourse aux dossards.";
            }

            return response;
        },
        actionSwitchParcours() {
            let response = {
                disabled: false,
                description: "pour ce participant",
                toPage: { name: 'ChangerParcours', params: { id_commande_inscription: this.inscription.id_commande_inscription } }
            }
            if (this.moduleClosed) {
                response.disabled = true;
                response.description = "Les inscriptions sont closes, vous ne pouvez plus changer de parcours";
            }
            if (this.inscription.inscription_sportive == 0) {
                response.disabled = true;
                response.description = "Le changement de parcours est indisponible pour une inscription non sportive.";
            }
            if (this.mainStore.module.is_complet) {
                response.disabled = true;
                response.description = "Le changement de parcours est indisponible car l'évènement est complet.";
            }
            if (!this.mainStore.module.autoriser_changement_course) {
                response.disabled = true;
                response.description = "Le changement de parcours n'est pas autorisé sur cet évènement.";
            }

            if (this.mainStore.module.has_limite_changement_course && this.$moment(this.mainStore.module.metadatas.limite_changement_course).endOf("day").isBefore(this.$moment())) {
                response.disabled = true;
                response.description = "Le date limite de changement de parcours est dépassée.";
            }
            if (this.all_commande_inscription.inscriptions.length > 1) {
                response.disabled = true;
                response.description = "Le changement de parcours n'est pas autorisé pour les inscriptions à des packs de courses.";
            }
            if (this.inscription.code_reduction != null) {
                response.disabled = true;
                response.description = "Le changement de parcours n'est pas autorisé pour les inscriptions ayant bénéficiée d'une réduction.";
            }
            if (this.inscription.course.type == "relais" || this.inscription.course.type == "duo") {
                response.disabled = true;
                response.description = "Le changement de parcours n'est pas autorisé pour les courses en équipe.";
            }
            if (this.inscription.bourse_dossards_status == 'PENDING') {
                response.disabled = true;
                response.description = "Vous ne pouvez pas changer de parcours car cette inscription est en vente sur la bourse aux dossards.";
            }
            return response;
        },
        showActionRefundGIA() {
            return this.gia;
        },
        showActionAlerteSMS() {
            return this.alerte_sms;
        },
        actionAlerteSMS() {
            let response = {
                disabled: false,
                description: "renseigner les numéros de téléphone de vos accompagnants",
                toPage: { name: 'EditAlerteSMSContacts', params: { id_inscription: this.inscription.id } }
            }
            return response;
        },
        actionRefundGIA() {
            let response = {
                disabled: false,
                description: "pour cette inscription",
                toPage: { name: 'RefundGIA', params: { id_inscription: this.inscription.id } }
            }
            if (!this.gia) {
                response.disabled = true;
                response.description = "La GIA n'est pas disponible pour cette inscription";
            }
            if (this.inscription.inscription_sportive == 0) {
                response.disabled = true;
                response.description = "Le remboursement via la GIA n'est pas disponible pour une inscription non sportive";
            }
            if (this.inscription.paye == 0) {
                response.disabled = true;
                response.description = "Le remboursement via la GIA n'est pas disponible pour une inscription non payée";
            }
            if (this.inscription?.refunds?.length > 0) {
                response.disabled = true;
                response.description = "Le remboursement via la GIA n'est pas disponible pour une inscription déjà remboursée";
            }
            if (this.inscription.supprime == 1) {
                response.disabled = true;
                response.description = "Le remboursement via la GIA n'est pas disponible pour une inscription supprimée";
            }
            if (this.inscription.transfere == 1) {
                response.disabled = true;
                response.description = "Le remboursement via la GIA n'est pas disponible pour une inscription transférée";
            }
            let date_event = this.$moment(this.mainStore.module.evenement.date_debut);
            let date_now = this.$moment();
            // si 3 jours avant l'évènement
            if (date_now.isAfter(date_event.subtract(3, "days"))) {
                response.disabled = true;
                response.description = "Le remboursement via la GIA n'est plus disponible";
            }
            return response;
        },
        moduleClosed() {
            return this.mainStore.module.status == 'apres_fermeture';
        }
    },
    methods: {
        deleteInscription() {
            this.deleteDialog = true;
        },
        async confirmDelete() {
            this.loadingDelete = true;
            let response = await UserService.deleteInscription(this.inscription.id);
            this.loadingDelete = false;
            this.deleteDialog = false;
            if (response) {

                this.mainStore.notification.send("Inscription supprimée avec succès");
                window.location.reload();
            } else {
                this.mainStore.notification.send("Erreur lors de la suppression de l'inscription", "error");
            }
        },
        async sendMailInscription() {
            let response = await UserService.sendInscriptionEmail(this.inscription.id);
            this.mainStore.notification.send(response);
        }
    }

}
</script>

<style lang="scss" scoped></style>